import { z } from 'zod'
import { camelizeKeys } from '@/functions/utils/index.js'

const CheckInClientBaseSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  phone_number: z.string(),
  selected_variant_ids: z.array(z.number()).default([]),
})

export const CheckInClientSchema = CheckInClientBaseSchema.transform(camelizeKeys)
export type CheckInClient = z.infer<typeof CheckInClientSchema>

const CheckInModePinCodeBaseSchema = z.object({
  pin: z.number(),
})

export const CheckInModePinCodeSchema = CheckInModePinCodeBaseSchema.transform(camelizeKeys)
export type CheckInModePinCode = z.infer<typeof CheckInModePinCodeSchema>

const ValidatePinResponseBaseSchema = z.object({
  status: z.enum(['ok', 'invalid']),
})

export const ValidatePinResponseSchema = ValidatePinResponseBaseSchema.transform(camelizeKeys)
export type ValidatePinResponse = z.infer<typeof ValidatePinResponseSchema>
